import {errorState, voucherState} from "../OTUpdateVoucherForm.js/states";
import {postRequest} from "./requests";
import {justDate} from "../../../../helpers/helpers";
import {isLoading, isNotLoading} from "../../../../actions/ui";
import axios from "axios";

export const handleChange = (stateFn, e) => {
    const {name,value,checked} = e.target
    if(name === 'active') {
        return stateFn(v => ({
            ...v,
            [name]:checked
        }))
    }
    return stateFn(v => ({
        ...v,
        [name]:value
    }))
}

const makeRequest = ({ method, url, data, needsToBeStored = false, storeType, headers }) => {
    return async(dispatch) => {
        dispatch( isLoading() );
        return await axios({ method, url, data, headers, responseType: 'blob' })
            .then(res => {
                typeof method === 'string' && needsToBeStored && dispatch(setInStore(storeType, res.data.data))
                dispatch( isNotLoading() );
                console.log(res.data);
                // Crear y descargar el archivo
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;

                // Extraer nombre del archivo de los headers o usar uno por defecto
                const contentDisposition = res.headers['content-disposition'];
                let fileName = `export_${data.date_from}_to_${data.date_to}.xlsx`;
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (fileNameMatch) {
                        fileName = fileNameMatch[1].replace(/['"]/g, '');
                    }
                }

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                return { message: 'La acción fue ejecutada con éxito', response : res.data.message}
            })
            .catch(err => {
                dispatch( isNotLoading() );
                return { message: 'La acción no pudo ser ejecutada', response : err.response.data.message}
            })
    }
}

const setInStore = (type, payload = null) => ({ type, payload})

export const submitValidation = ({voucher,rmaCollection}) => {

    const {
        date_from,
        date_to
    } = voucher

    if( !date_from ) return {status:true, message:'Seleccione una fecha desde'}
    if( !date_to ) return {status:true, message:'Seleccione una fecha hasta'}

    return false
}

export const submitFunction = ({ voucher, rmaCollection, setVoucher, setError, dispatch }) => {
    const {
        date_from,
        date_to
    } = voucher


    setError(errorState)

    postRequest.data = {
        date_from:justDate(date_from,true),
        date_to:justDate(date_to,true),
    }

    return new Promise((resolve) => {
        const aux = dispatch(makeRequest(postRequest))
        setVoucher(voucherState)
        resolve(aux)
        alert('Archivo exportado exitosamente');
    })
}